<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-arrow-rise`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 20h-7.5c-.073 0-.142-.012-.23-.024a1.555 1.555 0 01-.182-.045 1.474 1.474 0 01-.144-.048c-.024-.01-.048-.023-.072-.035-.048-.022-.097-.04-.144-.07-.376-.233-.614-.622-.7-1.09a1.67 1.67 0 01-.023-.238c0-.02-.005-.038-.005-.058 0-.033.007-.064.009-.097.003-.036.005-.07.01-.106a1.66 1.66 0 01.283-.755L22.561 3.989c.298-.557.882-1.082 1.439-.975.557-.107 1.14.418 1.44.975l11.258 13.445c.151.216.25.474.283.755.005.036.007.07.01.106.002.033.009.064.009.097 0 .02-.005.038-.005.058-.002.08-.01.159-.03.28-.079.426-.317.815-.693 1.049-.047.029-.096.047-.144.07-.024.01-.048.024-.072.034-.048.02-.096.034-.144.048-.06.018-.12.034-.2.046-.07.01-.14.023-.212.023H28v24a1 1 0 01-1 1h-6a1 1 0 01-1-1V20z"/></svg>
</template>
<script>

export default {
  name: 'IconArrowRise',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
